import { CreateAnswerDto } from "@/core/features/answers/create-answer.dto";
import { Expose } from "class-transformer";

export class UpdateAnswerDto extends CreateAnswerDto {
  @Expose()
  id: string;
}
